import React from "react";
import { PropTypes } from 'prop-types';

const TabPanel = ({ id, selectedTab, children }) => (
  <div
    id={id}
    role="tabpanel"
    aria-labelledby={id}
    hidden={selectedTab !== id}
    tabIndex={0}
    style={{ display: selectedTab === id ? 'block' : 'none' }}
  >
    {children}
  </div>
);

TabPanel.propTypes = {
  id: PropTypes.string.isRequired,
  selectedTab: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default TabPanel;